/* eslint-disable no-unused-vars */
import UpdateCommand from './UpdateCommand'
import CreateCommand from './CreateCommand'
import { firebase } from '@firebase/app'
import '@firebase/functions'
import {namis} from './../firebase.js'
import './../../../vue.config.js'

const Command = {
  execute: (command, payload) => {
    return Command[command] && Command[command](payload)
  },
  update: (payload) => { return UpdateCommand(payload) },
  create: (payload) => { return CreateCommand(payload) },
  updateReport: (payload) => {
    return firebase.functions().httpsCallable('updateReports')(payload)
  },
  updateTask: (payload) => {
    return firebase.functions().httpsCallable('updateTasks')(payload)
  },
  uploadTasks: (payload) => {
    return firebase.functions().httpsCallable('uploadTasks')(payload)
  },
  upMasterDatAID: (payload) => {
    return firebase.functions().httpsCallable('upMasterDatAID')(payload)
  },
  updatePlans: (payload) => {
    return firebase.functions().httpsCallable('updatePlans')(payload)
  },
  getPlanStatistics: (payload) => {
    return firebase.functions().httpsCallable('getPlanStatistics')(payload)
  },
  getStatistics: (payload) => {
    return firebase.functions().httpsCallable('getStatistics')(payload)
  },
  updateComment: (payload) => {
    return firebase.functions().httpsCallable('updateComment')(payload)
  },
  deleteComment: (payload) => {
    return firebase.functions().httpsCallable('deleteComment')(payload)
  },
  updateTaskManagement: (payload) => {
    return firebase.apps[1].functions().httpsCallable('updateTask')(payload)
  },
  deleteTaskManagemennt: (payload) => {
    return firebase.apps[1].functions().httpsCallable('deleteTask')(payload)
  },
  updateStaffInformation: (payload) => {
    return firebase.functions().httpsCallable('updateStaffInformation')(payload)
  },
  updateMeetingMinutes: (payload) => {
    return firebase.functions().httpsCallable('updateMeetingMinutes')(payload)
  },
}
export default {
  install (Vue, options) {
    Vue.prototype.$command = Command
  }
}
